{
  "footer": {
    "alreadyPartner": "Vai jau esat partneris?",
    "back": "Atpakaļ",
    "letsgo": "Aiziet",
    "login": "Pieteikties",
    "next": "Tālāk",
    "readMore": "Uzzināt vairāk",
    "signUp": "Reģistrēties"
  },
  "formErrors": {
    "address": "Šo adresi nevar atrast. Lūdzu, ievadiet jau esošu",
    "businessName": "Vārds nav pieejams. Lūdzu, izvēlieties citu",
    "email": "Šis e-pasts jau tiek izmantots",
    "verificationCode": "Nederīgs kods"
  },
  "global": {
    "title": "Pievienoties Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "Uzņēmuma nosaukums ir pārāk garš",
      "label": "Uzņēmuma nosaukums",
      "required": "Nepieciešams"
    },
    "businessSegment": {
      "aesthetics": "Estētika",
      "barber": "Barber",
      "beautician": "Kosmetologs",
      "hair-removal": "Matu noņemšana",
      "hairdresser": "Frizieris",
      "massage": "Masāža",
      "nails": "Nagi",
      "primary": "Galvenais",
      "required": "Atlasiet vismaz vienu",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Varu apliecināt, ka man ir atsevišķa telpa, kas paredzēta manam uzņēmumam.",
      "home": "Darbs mājās <0>- klienti ierodas pie jums mājās</0>",
      "mobile": "Mobils<0>- jūs dodaties pie saviem klientiem uz mājām</0>",
      "mobileCheckbox": "Es vēlos izmantot Treatwell TIKAI programmatūras rezervēšanai, NEVIS tirgum.",
      "mobileMessage": "Diemžēl ierobežojumu dēļ mūsu tirgus var parādīt tikai uzņēmumus ar fiksētu adresi.",
      "required": "Atlasiet vienu",
      "shop": "Veikals <0> — jūsu klienti ierodas veikalā</0>"
    },
    "city": {
      "invalid": "Pilsētas nosaukums pārāk garš",
      "label": "Pilsēta",
      "required": "Nepieciešams"
    },
    "country": {
      "label": "Valsts",
      "required": "Nepieciešams"
    },
    "email": {
      "invalid": "Nederīgs",
      "label": "E-pasts",
      "required": "Nepieciešams"
    },
    "firstName": {
      "invalid": "Lūdzu, neizmantojiet speciālās rakstzīmes",
      "label": "Vārds",
      "required": "Nepieciešams"
    },
    "lastName": {
      "invalid": "Lūdzu, neizmantojiet speciālās rakstzīmes",
      "label": "Uzvārds",
      "required": "Nepieciešams"
    },
    "marketing": {
      "label": "Es vēlos saņemt e-pasta ziņojumus, lai attīstītu savu uzņēmumu ar ekspertu padomiem"
    },
    "password": {
      "hint": "Jābūt vismaz 8 rakstzīmēm",
      "invalid": "Parolē jābūt vismaz 8 rakstzīmēm",
      "label": "Parole",
      "required": "Nepieciešama"
    },
    "phoneNumber": {
      "invalid": "Nederīgs tālruņa numurs",
      "label": "Telefona numurs",
      "required": "Nepieciešams"
    },
    "postalCode": {
      "invalid": "Pasta indekss ir pārāk garš",
      "label": "Pasta indekss",
      "required": "Nepieciešams"
    },
    "privacy": {
      "label": "Reģistrējoties Freemium kontam, jūs piekrītat mūsu <0>privātuma politikai</0> un <1>pakalpojumu sniegšanas noteikumiem</1>"
    },
    "searchBusiness": {
      "label": "Meklēt uzņēmumu"
    },
    "street": {
      "invalid": "Adrese ir pārāk gara",
      "label": "Adrese",
      "required": "Nepieciešama"
    }
  },
  "salesMode": {
    "enterPassword": "Ievadiet paroli pārdošanas režīmam",
    "invalidPassword": "Nederīga parole"
  },
  "stepContext": {
    "attractNewClients": "Piesaistiet jaunus klientus",
    "buildRelationships": "Izveidojiet vēl labākas attiecības ar saviem klientiem",
    "growBusiness": "Skaisti attīstiet savu uzņēmumu",
    "manageAppointments": "Pārvaldiet visus savus pierakstus, esot ceļā.",
    "prompt": "Jūs esat tikai dažu vienkāršu darbību (un apmēram 3 minūšu) attālumā, lai pievienotos 75 000 saloniem, kuri pārvalda savus uzņēmumus, attīsta savu klientu bāzi un gūst ieņēmumus.<br /><br />Ar Treatwell jūs varēsiet:",
    "prompt2": "...un vēl vairāk.",
    "title": "<0>Pievienoties Treatwell</0> - Eiropas lielākajai matu un skaistumkopšanas salonu platformai - vēl nekad nav bijis tik vienkārši."
  },
  "stepCounter": {
    "step0": "1. solis",
    "step1": "1. solis",
    "step2": "2. solis",
    "step3": "3. solis",
    "step4": "4. solis",
    "step5": "Apsveicam"
  },
  "stepEmailVerification": {
    "resend": "Sūtīt vēlreiz",
    "subTitle1": "Vienkārši ievadiet kodu, lai pabeigtu reģistrēšanos.",
    "subTitle2": "Vai nesaņēmāt?",
    "title": "<0> Gandrīz pabeigts.</0> Mēs esam nosūtījūši jums e-pastu ar 6 ciparu kodu!"
  },
  "stepError": {
    "accountCreation": "izveidojot savu kontu",
    "body": "Mēs saskaramies ar problēmām.\nLūdzu, nedaudz pagaidiet un mēģiniet vēlreiz.",
    "bodyWithError": "Mēs saskaramies ar problēmām saistībā ar {{reason}}. \nLūdzu, nedaudz pagaidiet un mēģiniet vēlreiz.",
    "button": "Mēģināt vēlreiz",
    "title": "Ak vai, kaut kas nogāja greizi!"
  },
  "stepFinal": {
    "joke1Punchline": "Šampūdelis!",
    "joke1Setup": "Kāds suns pieder frizierim?",
    "joke2Punchline": "Izvēloties īsāko griezumu!",
    "joke2Setup": "Kā frizieris uzvarēja sacensībās?",
    "joke3Punchline": "Bārbekjū!",
    "joke3Setup": "Kā jūs saucat vīriešus, kas stāv rindā pie barbera?",
    "joke4Punchline": "Aptumšojot tos!",
    "joke4Setup": "Kā cilvēks uz mēness veido savus matus?",
    "joke5Punchline": "stepFinal.joke5Punchline",
    "joke5Setup": "stepFinal.joke5Setup",
    "subTitle": "Kamēr gaidāt, šie ir daži jociņi",
    "title": "Paldies, uzstādīsim jūsu uzņēmumu!<br /> Dodiet mums <0>divas minūtes...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Reģistrēties",
    "alternativeMessage": "Vai izmantojat to pašu atrašanās vietu, lai reģistrētu jaunu uzņēmumu?",
    "button": "Treatwell pieteikšanās",
    "message": "<0>Labas ziņas!</0> Jūsu uzņēmums jau ir iestatīts ar Treatwell."
  },
  "stepFourForm": {
    "prompt1": "Mēs izmantosim šo informāciju, lai izveidotu jūsu kontu un vajadzības gadījumā sazinātos ar mums",
    "title": "Pastāstiet par sevi"
  },
  "stepOneForm": {
    "prompt1": "Meklējiet vai ievadiet uzņēmuma nosaukumu",
    "title": "Pastāstiet par savu uzņēmumu"
  },
  "stepOneSearch": {
    "addManually": "Nevarat atrast savu uzņēmumu? <0>Pievienojiet to manuāli</0>",
    "prompt1": "Ierakstiet sava uzņēmuma nosaukumu",
    "title": "Pastāstiet par savu uzņēmumu"
  },
  "stepThreeForm": {
    "title": "Kāda veida uzņēmums jums ir?"
  },
  "stepTwoForm": {
    "prompt1": "Atlasiet visus atbilstošos, vispirms savu galveno pakalpojumu",
    "title": "Kādus pakalpojumus jūs piedāvājat?"
  }
}